<button [ngClass]="buttonClass" type="button" (click)="onClick($event)">
  <i [ngClass]="iconClass"></i><span>{{ buttonText }}</span>
</button>
